<template>
  <xcurd :topBtns="topBtns" :dialogs="dialogs" :table="table" @clickRowBtn="" @clickMultiBtn="" @clickTopBtn=""></xcurd>
</template>
<script>
import Xcurd from 'xelement/curd'
import { api } from 'src/config'

export default {
  data() {
    return {
      topBtns: false,
      dialogs: [
        {
          id: 'edit',
          title: '查看订单',
          isClose: true,
          form: {
            data: {
              tel: '',
              name: '',
              address: '',
              prod: '',
              remark: '',
              remark2: '',
              seller: null,
              sum: 0,
              paytype: '',
              worker_name: '',
              tel_worker: '',
              rank: '',
              sendren: '',
              state: ''
            },
            config: {
              base: {
                labelWidth: '100px'
              },
              submit: false,//{
              //   btnText: '提交',
              //   url: api.oldOrder.edit
              // },
              item: [
                [
                  {
                    span: 12,
                    id: 'name',
                    title: '客户名字',
                    type: 'input'
                  },
                  {
                    span: 12,
                    id: 'tel',
                    title: '客户电话',
                    type: 'input'
                  }
                ],
                [
                  {
                    span: 12,
                    id: 'address',
                    title: '客户地址',
                    type: 'input'
                  },
                  {
                    span: 12,
                    id: 'prod',
                    title: '产品',
                    type: 'textarea',
                    config: {
                      authsize: {
                        min: 3,
                        max: 6
                      },
                      rows: 4,
                    }
                  }
                ],
                [
                  {
                    span: 12,
                    id: 'seller',
                    title: '商家',
                    type: 'select_remote',
                    config: {
                      url: api.seller.query,
                      textField: 'name',
                      valueField: 'id'
                    }
                  },
                  {
                    span: 12,
                    id: 'sum',
                    title: '订单金额',
                    type: 'input'
                  }
                ],
                // [
                //   {
                //     span: 12,
                //     id: 'worker_name',
                //     title: '师傅名字',
                //     type: 'input'
                //   },
                //   {
                //     span: 12,
                //     id: 'tel_worker',
                //     title: '师傅电话',
                //     type: 'input'
                //   }
                // ],
                [
                  {
                    // span: 12,
                    id: 'paytype',
                    title: '支付方式',
                    type: 'radio',
                    data: [
                      {
                        id: 'client',
                        text: '客户付款'
                      },
                      {
                        id: 'seller',
                        text: '商家付款'
                      }
                    ],
                    config: {
                      type: 'btn'
                    }
                  }
                  // {
                  //   span: 12,
                  //   id: 'rank',
                  //   title: '评级',
                  //   type: 'input'
                  // }
                ],
                [
                  {
                    span: 12,
                    id: 'sendren',
                    title: '派单人',
                    type: 'input'
                  },
                  {
                    span: 12,
                    id: 'state',
                    title: '订单状态',
                    type: 'select',
                    data: [
                      {
                        id: 'creat',
                        text: '已下单'
                      },
                      {
                        id: 'msg',
                        text: '发信息'
                      },
                      {
                        id: 'finish',
                        text: '已安装'
                      },
                      {
                        id: 'done',
                        text: '结单'
                      },
                      {
                        id: 'close',
                        text: '已取消'
                      }
                    ]
                  }
                ]
                // [
                //   {
                //     span: 12,
                //     id: 'remark',
                //     title: '订单备注',
                //     type: 'input'
                //   },
                //   {
                //     span: 12,
                //     id: 'remark2',
                //     title: '处理备注',
                //     type: 'input'
                //   }
                // ]
              ]
            }
          }
        }
      ],
      table: {
        data: api.oldOrder.getList,
        config: {
          base: {
            showIndex: false
          },
          selection: false,
          expand: false,
          query: {
            data: {
              status: 'all',
              paytype: 'all',
              address: '',
              prod: '',
              str: ''
            },
            form: [
              {
                id: 'status',
                type: 'radio',
                data: [
                  {
                    id: 'all',
                    text: '全部'
                  },
                  {
                    id: 'creat',
                    text: '已下单'
                  },
                  {
                    id: 'msg',
                    text: '发信息'
                  },
                  {
                    id: 'finish',
                    text: '已安装'
                  },
                  {
                    id: 'done',
                    text: '结单'
                  },
                  {
                    id: 'close',
                    text: '已取消'
                  }
                ]
              },
              {
                id: 'paytype',
                type: 'radio',
                data: [
                  {
                    id: 'all',
                    text: '全部'
                  },
                  {
                    id: 'client',
                    text: '客户付款'
                  },
                  {
                    id: 'seller',
                    text: '商家付款'
                  }
                ]
              },
              {
                id: 'address',
                type: 'input',
                placeholder: '请输入地区'
              },
              {
                id: 'prod',
                type: 'input',
                placeholder: '请输入服务'
              },
              {
                id: 'str',
                type: 'input',
                placeholder: '请输入关键字'
              }
            ]
          },
          rowBtns: {
            config: {
              width: '220',
              isFixed: true
            },
            list: [
              {
                id: 'edit',
                icon: 'edit',
                text: '查看详情',
                dialog: 'edit'
              }
              // {
              //   id: 'del',
              //   type: 'danger',
              //   icon: 'delete',
              //   ajax: {
              //     confirm: '是否确认删除？',
              //     url: api.oldOrder.del,
              //     param: ['id']
              //   }
              // },
              // {
              //   id: 'top',
              //   text: '置顶',
              //   show: {
              //     field: 'is_top',
              //     val: '0'
              //   },
              //   ajax: {
              //     confirm: '是否确认置顶？',
              //     url: api.oldOrder.setTop,
              //     param: ['id'],
              //     paramCustom: {
              //       val: 1
              //     }
              //   }
              // },
              // {
              //   id: 'untop',
              //   text: '取消置顶',
              //   show: {
              //     field: 'is_top',
              //     val: '0',
              //     type: 'uneq'
              //   },
              //   ajax: {
              //     confirm: '是否确认取消置顶？',
              //     url: api.oldOrder.setTop,
              //     param: ['id'],
              //     paramCustom: {
              //       val: 0
              //     }
              //   }
              // }
            ]
          },
          page: true,
          field: [
            // {
            //   fixed: true,
            //   id: 'name',
            //   text: '师傅名称',
            //   width: '180',
            //   tooltip: true
            // },
            {
              fixed: true,
              id: 'name',
              text: '客户姓名',
              width: '120'
            },
            {
              id: 'tel',
              text: '客户电话',
              width: '140'
            },
            {
              id: 'prod',
              text: '服务内容',
              width: '360',
              tooltip: true
            },
            {
              id: 'address',
              text: '客户地址',
              width: '240',
              tooltip: true
            },
            {
              id: 'sum',
              text: '订单金额',
              width: '240',
              tooltip: true
            },
            {
              id: 'time_creat',
              text: '创建时间',
              width: '160'
            },
            {
              id: 'time_finish',
              text: '完成时间',
              width: '160'
            },
            // {
            //   id: 'rank',
            //   text: '评价',
            //   width: '140',
            //   tooltip: true
            // },
            // {
            //   id: 'tel_worker',
            //   text: '师傅电话',
            //   width: '240',
            //   tooltip: true
            // },
            {
              id: 'state',
              text: '订单状态',
              width: '120',
              formatter: 'oldOrderState'
            },
            {
              id: 'sendren',
              text: '派单员',
              width: '120'
            }
          ]
        }
      }
    }
  },
  methods: {
    
  },
  components: {
    Xcurd
  }
}
</script>


// WEBPACK FOOTER //
// order_old.vue?4a06f36e